import { EventType } from '@/models/Interaction';
import { fetchReportStateByWidgetId } from '@/store/thunks/FetchReport';
import { getChatAPI } from '@/api/ChatApi';
import { getCurrentThread } from '@/store/reducers/UIState';
import { MessageId } from '@/models/Message';
import { mkReportChipTrackAttrs } from '@/analytics/props/inlineWidget';
import { openReportWidget } from '@/store/actionCreators/WidgetActions';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { WidgetEvent, WidgetType } from '@/models/PanelWidgets';

import { Button } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

type InlineReportWidgetProps = {
  reportId: string;
  messageId: MessageId;
};

export function InlineReportWidget({
  reportId,
  messageId,
}: InlineReportWidgetProps) {
  const chatApi = getChatAPI();
  const dispatch = useAppDispatch();
  const currentThread = useAppSelector(getCurrentThread);

  const openReport = () => {
    if (!currentThread) {
      return;
    }

    // optimistically open the report panel
    dispatch(
      openReportWidget({
        currentThreadId: currentThread.id,
        reportData: null,
      }),
    );

    // fetch the report state by widget id
    dispatch(
      fetchReportStateByWidgetId({
        threadId: currentThread?.id,
        widgetId: reportId,
      }),
    );

    chatApi.trackEvent({
      type: EventType.UI_INTERACTION,
      threadId: currentThread.id,
      messageId,
      data: {
        widget_type: WidgetType.REPORT,
        event_type: WidgetEvent.WIDGET_OPEN,
      },
    });
  };

  return (
    <Button
      onClick={openReport}
      size="small"
      data-testid="report-widget-button"
      {...mkReportChipTrackAttrs({ messageId, reportId })}
    >
      View report <ChevronRightIcon />
    </Button>
  );
}
